import { generatePeriodTimeMatchInfo } from 'editor/components/SideBar/Qualify/limitPlayTimes/periodPlay/utils';

export default function getPeriodPlayMatchedInfo({ periodPlayMode, periodTime, timezone }) {
    const isPeriodPlayMode = Boolean(periodPlayMode) && Boolean(periodTime);

    return {
        isPeriodPlayMode,
        matchedInfo: generatePeriodTimeMatchInfo(isPeriodPlayMode, {
            timezone,
            periodTimes: periodTime,
            mode: periodPlayMode
        })
    };
}
